// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-alert.inline-flex{display:inline-flex}.el-alert.text-black{color:#303030}.el-alert.text-black .el-alert__description{color:#303030;font-size:.875rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
